<script>
import { SHARE_ACTION_OPTIONS } from '../../constant'
export default {
  props: {
    currentImage: {
      type: Object,
      default: () => ({})
    },
    clickable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      SHARE_ACTION_OPTIONS
    }
  },
  computed: {
    shareActionOptions () {
      const key = this.currentImage.key
      if (key === 'interestTable') {
        return SHARE_ACTION_OPTIONS.filter(e => !['wechat_timeline', 'qq_friends', 'print'].includes(e.key))
      }
      return SHARE_ACTION_OPTIONS.filter(e => !['theme', 'setting'].includes(e.key))
    }
  },
  methods: {
    handleShare(option = {}) {
      this.$emit('handle', option.key)
    },
  },
}
</script>
<template>
  <div class="export_images_actions">
    <figure
      v-for="option in shareActionOptions"
      :key="option.key"
      @click="handleShare(option)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 90 90"
        version="1.1"
        v-html="option.svgData"
      />
      <figcaption>{{ option.name }}</figcaption>
    </figure>
  </div>
</template>
<style lang="postcss" scoped>
.export_images_actions {
  display: flex;
  & figure {
    flex: 1;
    & svg {
      width: 45px;
      height: 45px;
      margin-bottom: 4px;
    }
  }
}
</style>